(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    /* StickyHeader registered inline */
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mv-air-filter-cartridge-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.mv-cfp').forEach(function(section){
    section.querySelectorAll('[data-media-target]').forEach(function(button){
      button.addEventListener('click', function(){
        var target = button.dataset.mediaTarget;
        section.querySelectorAll('[data-media-id]').forEach(function(media){ media.classList.toggle('is-hidden', media.dataset.mediaId !== target); });
        section.querySelectorAll('[data-media-target]').forEach(function(thumb){
          var active = thumb === button;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });
    section.querySelectorAll('[data-variant]').forEach(function(button){
      button.addEventListener('click', function(){
        if(button.disabled) return;
        section.querySelectorAll('[data-variant]').forEach(function(item){ item.classList.remove('is-selected'); });
        button.classList.add('is-selected');
        section.querySelector('[data-variant-id]').value = button.dataset.variant;
        section.querySelector('[data-selected-price]').textContent = button.dataset.price;
        var available = button.dataset.available === 'true';
        section.querySelector('[data-add-button]').disabled = !available;
        section.querySelector('[data-add-label]').textContent = available ? 'Add cartridge to cart' : 'Unavailable';
      });
    });
    var qty = section.querySelector('[data-qty]');
    section.querySelector('[data-qty-minus]').addEventListener('click', function(){ qty.value = Math.max(1, Number(qty.value || 1) - 1); });
    section.querySelector('[data-qty-plus]').addEventListener('click', function(){ qty.value = Math.max(1, Number(qty.value || 1) + 1); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mv-air-filtration-guide"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-industry-carousel]').forEach(function(carousel){
    var track = carousel.querySelector('[data-industry-track]');
    var previous = carousel.querySelector('[data-industry-prev]');
    var next = carousel.querySelector('[data-industry-next]');
    var timer;
    if (!track || !previous || !next) return;
    function step(direction){
      var card = track.querySelector('.mv-afg__industry-card');
      var distance = card ? card.getBoundingClientRect().width + 18 : track.clientWidth * .8;
      track.scrollBy({left: distance * direction, behavior: 'smooth'});
    }
    function start(){
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      window.clearInterval(timer);
      timer = window.setInterval(function(){
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
        if (atEnd) track.scrollTo({left: 0, behavior: 'smooth'});
        else step(1);
      }, 6000);
    }
    previous.addEventListener('click', function(){ step(-1); start(); });
    next.addEventListener('click', function(){ step(1); start(); });
    carousel.addEventListener('mouseenter', function(){ window.clearInterval(timer); });
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', function(){ window.clearInterval(timer); });
    carousel.addEventListener('focusout', start);
    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mv-air-filtration-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.mv-afp').forEach(function(section){
    section.querySelectorAll('[data-media-target]').forEach(function(button){
      button.addEventListener('click', function(){
        var target = button.getAttribute('data-media-target');
        section.querySelectorAll('[data-media-id]').forEach(function(media){
          media.classList.toggle('is-hidden', media.getAttribute('data-media-id') !== target);
        });
        section.querySelectorAll('[data-media-target]').forEach(function(thumb){
          var active = thumb === button;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mv-forvane-flap-disc-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mvf-product]').forEach((root) => {
    const variantsNode = root.querySelector('[data-product-variants]');
    if (!variantsNode) return;
    const variants = JSON.parse(variantsNode.textContent);
    const groups = [...root.querySelectorAll('[data-option-position]')];
    const idInput = root.querySelector('[data-variant-id]');
    const priceNode = root.querySelector('[data-product-price]');
    const unitNode = root.querySelector('[data-unit-price]');
    const skuNode = root.querySelector('[data-product-sku]');
    const addButton = root.querySelector('[data-add-button]');
    const addText = root.querySelector('[data-add-text]');
    const currency = root.dataset.currency || 'CAD';
    const addLabel = addText ? addText.textContent.trim() : '';
    const unavailableLabel = 'Unavailable';
    const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
      style: 'currency',
      currency
    }).format(Number(cents) / 100);
    const selectedOptions = () => groups.map((group) => {
      const selected = group.querySelector('[data-option-value].is-selected');
      return selected ? selected.dataset.optionValue : '';
    });
    const updateVariant = () => {
      const options = selectedOptions();
      const variant = variants.find((item) => item.options.every((value, index) => value === options[index]));
      if (!variant) {
        addButton.disabled = true;
        addText.textContent = unavailableLabel;
        return;
      }
      idInput.value = variant.id;
      priceNode.textContent = formatMoney(variant.price);
      skuNode.textContent = variant.sku || '';
      const packOption = options.find((value) => value.includes('Pack')) || '1';
      const packQuantity = Math.max(1, parseInt(packOption, 10) || 1);
      unitNode.textContent = formatMoney(Math.round(Number(variant.price) / packQuantity));
      addButton.disabled = !variant.available;
      addText.textContent = variant.available ? addLabel : unavailableLabel;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    groups.forEach((group) => {
      group.querySelectorAll('[data-option-value]').forEach((button) => {
        button.addEventListener('click', () => {
          group.querySelectorAll('[data-option-value]').forEach((item) => {
            item.classList.remove('is-selected');
            item.setAttribute('aria-pressed', 'false');
          });
          button.classList.add('is-selected');
          button.setAttribute('aria-pressed', 'true');
          updateVariant();
        });
      });
    });
    root.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        const index = button.dataset.galleryThumb;
        root.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.classList.remove('is-active'));
        root.querySelectorAll('[data-gallery-slide]').forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
        root.querySelector(`[data-gallery-slide="${index}"]`)?.classList.add('is-active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
